import React, { useEffect, useState, useRef } from 'react'
import Swal from 'sweetalert2';
import { addDoc, collection, doc, getDoc, getDocs, onSnapshot, orderBy, query, Timestamp, updateDoc, where } from 'firebase/firestore';
import { auth, db } from '../../firebase';
import "../../App.css";
import moment from 'moment';
import { useReactToPrint } from 'react-to-print';
import Menu from '../../panel/Menu';

function Collectionreport() {
    const Toast = Swal.mixin({
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
            toast.addEventListener('mouseenter', Swal.stopTimer)
            toast.addEventListener('mouseleave', Swal.resumeTimer)
        }
    });
    useEffect(() => {
        auth.onAuthStateChanged((user) => {
            setUserData(user);
            fethUsers()
        });
    });
    const printRef = useRef();
    const [loading, setloading] = useState(false);
    const [loadincount, setloadincount] = useState(true);
    const [userData, setUserData] = useState();
    const [fromDate, setfromDate] = useState("");
    const [toDate, settoDate] = useState("");
    const [payhistory, setpayhistory] = useState([]);
    const [paymodes, setpaymodes] = useState([]);
    const [total, settotal] = useState(0);


    const fethUsers = async () => {
        try {
            if (userData) {
                if (loadincount) {
                    const docRef = doc(db, "users", userData.uid)
                    const docSnap = await getDoc(docRef)
                    if (docSnap.exists()) {
                        setloadincount(false)
                    }

                }
            }
        } catch (error) {
            console.log(error);
        }
    }


    const getReport = async () => {
        if (!fromDate || !toDate) {
            Toast.fire({ icon: "error", title: "Please select From Date & To Date" });
            return;
        }

        setloading(false);
        setpaymodes([]);
        setpayhistory([]);

        const today = new Date(fromDate);
        today.setHours(0, 0, 0, 0);

        const tomorrow = new Date(toDate);
        tomorrow.setDate(tomorrow.getDate() + 1);

        const startDate = Timestamp.fromDate(today);
        const endDate = Timestamp.fromDate(tomorrow);

        try {
            // Query payhistory
            const q1 = query(
                collection(db, "payhistory"),
                where("type", "!=", "Advance Booking"),
                where("status", "==", "Working"),
                where("createdAt", ">=", startDate),
                where("createdAt", "<", endDate)
            );

            const q2 = query(collection(db, "paymentmodes"));

            // Run both queries in parallel
            const [payhistorySnapshot, paymentModesSnapshot] = await Promise.all([
                getDocs(q1),
                getDocs(q2),
            ]);

            // Process payhistory data including 'rooms' and 'customers'
            const payhistoryData = await Promise.all(
                payhistorySnapshot.docs.map(async (doc1) => {
                    const docData = doc1.data();

                    // Fetch both payment modes in parallel
                    const [paymode1DocSnap, paymode2DocSnap] = await Promise.all([
                        getDoc(doc(db, "paymentmodes", docData.paymode1)),
                        getDoc(doc(db, "paymentmodes", docData.paymode2)),
                    ]);

                    const paymode1 = paymode1DocSnap.exists() ? paymode1DocSnap.data().paymode : "";
                    const paymode2 = paymode2DocSnap.exists() ? paymode2DocSnap.data().paymode : "";

                    // Format the createdAt date
                    const date = docData.createdAt.toDate();
                    const createdat = date
                        .toISOString()
                        .replace("T", " ")
                        .slice(0, 19);

                    // Extract 'rooms' and 'customers' arrays
                    const rooms = docData.rooms || [];
                    const customers = docData.customers || [];

                    return {
                        id: doc1.id,
                        data: docData,
                        paymode1,
                        paymode2,
                        createdat,
                        rooms,         // Add rooms array
                        customers,     // Add customers array
                    };
                })
            );

            console.log(payhistoryData);
            setpayhistory(payhistoryData);

            // Process payment modes and total calculation
            const paymentModesData = await Promise.all(
                paymentModesSnapshot.docs.map(async (doc1) => {
                    const paymodeId = doc1.id;
                    const paymode = doc1.data().paymode;

                    // Fetch totals for both paymode1 and paymode2 in parallel
                    const [paymode1TotalSnapshot, paymode2TotalSnapshot] = await Promise.all([
                        getDocs(
                            query(
                                collection(db, "payhistory"),
                                where("type", "!=", "Advance Booking"),
                                where("status", "==", "Working"),
                                where("paymode1", "==", paymodeId),
                                where("createdAt", ">=", startDate),
                                where("createdAt", "<", endDate)
                            )
                        ),
                        getDocs(
                            query(
                                collection(db, "payhistory"),
                                where("type", "!=", "Advance Booking"),
                                where("status", "==", "Working"),
                                where("paymode2", "==", paymodeId),
                                where("createdAt", ">=", startDate),
                                where("createdAt", "<", endDate)
                            )
                        ),
                    ]);

                    const total1 = paymode1TotalSnapshot.docs.reduce(
                        (sum, doc) => sum + (doc.data().amount1 || 0),
                        0
                    );
                    const total2 = paymode2TotalSnapshot.docs.reduce(
                        (sum, doc) => sum + (doc.data().amount2 || 0),
                        0
                    );

                    const newTotal = (total1 + total2).toFixed(0);

                    return {
                        id: paymodeId,
                        paymode,
                        totalamount: newTotal,
                    };
                })
            );

            const totalAmount = paymentModesData.reduce(
                (sum, mode) => sum + parseFloat(mode.totalamount),
                0
            );

            settotal(totalAmount.toFixed(0));
            setpaymodes(paymentModesData);
        } catch (error) {
            console.error(error);
        }

        setloading(true);
    };


    const handlePrint = useReactToPrint({
        content: () => printRef.current,
    })

    const handleFromDate = (e) => {
        setfromDate(e.target.value)
        setloading(false)
    }
    const handleToDate = (e) => {
        settoDate(e.target.value)
        setloading(false)
    }

    return (
        <div>
            <Menu />
            <div className="content-wrapper">
                <section className="content mt-2">
                    <div className="container-fluid">
                        <button className="btn btn-secondary " >||  Collection Report ||</button><br /><br />
                        <div className="row">
                            <div className="col-md-12">
                                <div className="card card-primary card-outline">
                                    <div className="card-body">
                                        <div className='row'>
                                            <div className='col-sm-4'>
                                                <label>From Date</label>
                                                <input type='date' value={fromDate} onChange={handleFromDate} className='form-control' />
                                            </div>
                                            <div className='col-sm-4'>
                                                <label>To Date</label>
                                                <input type='date' value={toDate} onChange={handleToDate} className='form-control' />
                                            </div>
                                            <div className='col-sm-3'>
                                                <br />
                                                <button className='btn btn-info' onClick={getReport}>Get Report</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {
                                    loading &&
                                    <>
                                        <div className="card card-primary card-outline" ref={printRef}>
                                            <div className="card-body">
                                                <div className="row invoice-info">
                                                    <div className="col-sm-12 invoice-col text-center">
                                                        <address>
                                                            <h4>Dasara Executive</h4>
                                                            Chatrapati Shivaji Maharaj Chouk, Tuljapur, Dist - Dharashiv, MH - 413601<br />
                                                            Phone: +91 9975294940 |
                                                            Email:  dasaraexecutive@gmail.com<br />
                                                            Website:  www.dasaraexecutive.com
                                                        </address>
                                                    </div>
                                                </div>
                                                <div className='row'>
                                                    <table className='customers2 '>
                                                        <tr>
                                                            <th style={{ textAlign: "center" }}>From Date : {moment(fromDate).format('DD/MM/YYYY')}  </th>
                                                            <th style={{ textAlign: "center" }}><h5>COLLECTION REPORT </h5></th>
                                                            <th style={{ textAlign: "center" }}>To Date : {moment(toDate).format('DD/MM/YYYY')}</th>
                                                        </tr>
                                                    </table>

                                                    <table className="customers" style={{ width: "100%" }}>
                                                        <thead>
                                                            <tr>
                                                                <th style={{ backgroundColor: "#E0FCFE" }} colSpan={10}>Collection Reports</th>
                                                            </tr>
                                                            <tr>
                                                                <th>Paymode Type</th>
                                                                <th>Customer</th>
                                                                <th>Room No</th>
                                                                <th>Paymode1</th>
                                                                <th style={{ textAlign: "right" }}>Amount1</th>
                                                                {/* <th>Paynote1</th> */}
                                                                <th>Paymode2</th>
                                                                <th style={{ textAlign: "right" }}>Amount2</th>
                                                                {/* <th>Paynote2</th> */}
                                                                <th>Datetime</th>
                                                                <th>Note</th>
                                                                {/* <th>Username</th> */}
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {
                                                                payhistory.map((item, index) =>
                                                                    <tr key={index}>
                                                                        <td>
                                                                            {
                                                                                item.data.type === 'Payments Taken from Customers' ?
                                                                                    <span>Pending Payment Recieved</span> :
                                                                                    <span>{item.data.type}</span>
                                                                            }
                                                                        </td>
                                                                        <td>{item.customers.custname}</td>
                                                                        <td>
                                                                            <div className='row'>
                                                                                {item.rooms.map((item1, index) =>
                                                                                    <span key={index}>&nbsp; {item1.roomname} &nbsp;  </span>
                                                                                )}
                                                                            </div>
                                                                        </td>
                                                                        <td>{item.paymode1}</td>
                                                                        <td style={{ textAlign: "right" }}>{parseFloat(item.data.amount1).toFixed(0)}</td>
                                                                        {/* <td>{item.data.paytime1}</td> */}
                                                                        <td>{item.paymode2}</td>
                                                                        <td style={{ textAlign: "right" }}>{parseFloat(item.data.amount2).toFixed(0)}</td>
                                                                        {/* <td>{item.data.paytime2}</td> */}
                                                                        <td>{item.createdat}</td>
                                                                        <td>{item.data.note}</td>
                                                                        {/* <td>{item.data.username}</td> */}
                                                                    </tr>
                                                                )
                                                            }
                                                        </tbody>
                                                    </table>
                                                    <hr />
                                                    <table className='customers' style={{ width: "25%" }}>
                                                        <thead>
                                                            <tr>
                                                                <th>Paymodes</th>
                                                                <th style={{ textAlign: "right" }}>Amount</th>
                                                            </tr>
                                                            {
                                                                paymodes.map((item, index) =>
                                                                    <tr key={index}>
                                                                        <td >{item.paymode}</td>
                                                                        <td style={{ textAlign: "right" }}>{item.totalamount}</td>
                                                                    </tr>
                                                                )
                                                            }
                                                        </thead>
                                                    </table><br />
                                                    <table className='customers2'>
                                                        <thead>
                                                            <tr>
                                                                <th style={{ backgroundColor: "#E0FCFE" }}> <h6> Total Collection of :  Rs. {total} /- </h6></th>
                                                            </tr>

                                                        </thead>
                                                    </table>
                                                </div>
                                            </div>

                                        </div>
                                        <center>
                                            <button className='btn btn-success' onClick={handlePrint}>Print Report</button>
                                        </center>
                                    </>
                                }

                            </div>
                        </div>
                    </div>
                </section >




            </div>



        </div >

    )
}

export default Collectionreport
